var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "viewWrapper",
      class: ["editorView", { standalone: _vm.standalone }],
    },
    [
      _vm.showPhotoToolbar
        ? _c("div", {
            staticClass: "modal",
            on: {
              mousedown: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                _vm.showPhotoToolbar = false
              },
              touchstart: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                _vm.showPhotoToolbar = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.pageModel
        ? _c(
            "div",
            {
              key: "photoToolbar",
              class: [
                "toolbarFull",
                { collapsed: !_vm.showPhotoToolbar },
                "overModal",
              ],
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                },
                touchstart: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("PhotoToolbarView", {
                attrs: {
                  "is-visible": _vm.showPhotoToolbar,
                  "page-objects": _vm.toolbarPhotoPageObjects,
                  "photos-queued": _vm.toolbarPhotoPhotosQueued,
                  "product-photos": _vm.toolbarPhotoProductPhotos,
                  "picker-max": _vm.pickerMax,
                  "picker-remove-unselected": false,
                  "picker-show-selection": false,
                  "show-light-box": _vm.showLightBox,
                },
                on: {
                  close: _vm.closePhotoToolbar,
                  externalUploadCompleted: _vm.externalUploadCompleted,
                  openLightBox: _vm.openLightBox,
                  selectPhoto: _vm.selectPhoto,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activePhotoModel
        ? _c("ImportLightBoxView", {
            attrs: {
              "photo-model": _vm.activePhotoModel,
              "show-select-button": true,
            },
            on: {
              closeLightBox: _vm.closeLightBox,
              selectPhoto: _vm.addPhotoToPage,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("TopToolbarView", {
        attrs: {
          "has-action-button": false,
          "has-proceed-button": _vm.standalone,
          "has-undo-redo-button": true,
          "menu-items": _vm.menuItems,
          "fixed-position": _vm.standalone,
          "inverse-colors": !_vm.standalone,
        },
        on: {
          clickBackButton: _vm.goBack,
          clickProceedButton: _vm.goForward,
          clickRedoButton: _vm.redo,
          clickUndoButton: _vm.undo,
        },
        scopedSlots: _vm._u(
          [
            !_vm.standalone
              ? {
                  key: "backButtonIcon",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("\n\t\t\t\tclose\n\t\t\t"),
                      ]),
                    ]
                  },
                  proxy: true,
                }
              : null,
            !_vm.standalone
              ? {
                  key: "backButtonText",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n\t\t\t" + _vm._s(_vm.$t("buttonClose")) + "\n\t\t"
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "proceedButtonText",
              fn: function () {
                return [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("views.editor.proceedButton")) +
                      "\n\t\t"
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "selectMenuHeader",
              fn: function () {
                return [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("selectMenu.headers.applyToPage")) +
                      "\n\t\t"
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "verticalCenter" }, [
        _c(
          "div",
          { staticClass: "editorBox", style: _vm.editorBoxStyle },
          [
            _vm.pageModel
              ? _c("EditorBoxView", {
                  attrs: {
                    "page-model": _vm.pageModel,
                    "max-height": _vm.editorBoxHeight,
                  },
                  on: { displayWidth: _vm.setPageBrowserWidth },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.standalone
          ? _c(
              "div",
              {
                ref: "pageBrowserBox",
                staticClass: "pageBrowserBox noUserSelect",
                style: _vm.pageBrowserBoxStyle,
              },
              [
                _c("div", { staticClass: "pageBrowserButtonWrapper" }, [
                  _vm.showLeftFlip
                    ? _c(
                        "div",
                        {
                          staticClass: "pageBrowserButtonLeft inverse",
                          on: {
                            mousedown: _vm.goToPreviousPage,
                            touchstart: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.goToPreviousPage.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("\n\t\t\t\t\t\tchevron_left\n\t\t\t\t\t"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pageBrowserStatus" }, [
                  _vm.showLeftFlip || _vm.showRightFlip
                    ? _c("div", { staticClass: "pageNumber" }, [
                        _c("span", [_vm._v(_vm._s(_vm.pageLabel))]),
                        _vm._v(" "),
                        _vm.pageCountLabel
                          ? _c("span", [
                              _vm._v(
                                "\n\t\t\t\t\t\t/ " +
                                  _vm._s(_vm.pageCountLabel) +
                                  "\n\t\t\t\t\t"
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pageBrowserButtonWrapper" }, [
                  _vm.showRightFlip
                    ? _c(
                        "div",
                        {
                          staticClass: "pageBrowserButtonRight inverse",
                          on: {
                            mousedown: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.goToNextPage.apply(null, arguments)
                            },
                            touchstart: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.goToNextPage.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("\n\t\t\t\t\t\tchevron_right\n\t\t\t\t\t"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.standalone
        ? _c(
            "div",
            {
              ref: "floatButton",
              class: [
                "actionbutton",
                "floatButton",
                "altColor",
                { moveUp: _vm.isObjectToolbarShown },
              ],
              attrs: { id: "tourHandleProceedButtonMobile" },
              on: {
                touchstart: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.goForward.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n\t\t" + _vm._s(_vm.$t("views.editor.proceedButton")) + "\n\t"
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }